import { render } from "./Rehabit.vue?vue&type=template&id=d2683c9e&scoped=true"
import script from "./Rehabit.vue?vue&type=script&lang=js"
export * from "./Rehabit.vue?vue&type=script&lang=js"

import "./Rehabit.vue?vue&type=style&index=0&id=d2683c9e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d2683c9e"

export default script